import { ProductType } from '@inter-ikea-storageone/range';
import { SelectedMenu, SelectedMenuProductList } from 'rangeConfig/@types';
import addInteriorToSection from 'rangeConfig/boaxel/behaviors/addInteriorToSection';
import deleteSection from 'rangeConfig/boaxel/behaviors/deleteSection';
import {
  requireSelectedWidth,
  requiresSelectedColour
} from 'rangeConfig/boaxel/filters/selectedMenuProductFilters';
import ChangeSelectedSectionWidth from 'rangeConfig/boaxel/widgets/ChangeSelectedSectionWidth';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import platform from 'rangeConfig/shared/utils/platform';

const interiors: SelectedMenuProductList = {
  id: 'sections-selected-menu-interiors',
  title: 'storageone.productListInteriorsTitle',
  cardsSubtitle: 'typeName, communicatedSizeText',
  filters: [],
  behaviors: {
    productClicked: [addInteriorToSection],
    productDropped: [addProduct]
  },
  productTypes: [
    ProductType.BOAXEL_SHELF,
    ProductType.BOAXEL_ADJ_SHELF,
    ProductType.BOAXEL_SHOE_SHELF,
    ProductType.BOAXEL_WIRE_SHELF,
    ProductType.BOAXEL_DRYING_RACK,
    ProductType.BOAXEL_MESH_BASKET,
    ProductType.BOAXEL_METAL_SHELF
  ],
  productFilters: [requiresSelectedColour, requireSelectedWidth],
  cluster: ['type', 'design']
};

const widgets = {
  desktop: [
    {
      id: 'change-section-width',
      component: ChangeSelectedSectionWidth
    },
    interiors
  ],
  mobile: [
    {
      id: 'change-section-width',
      title: 'storageone.width',
      component: ChangeSelectedSectionWidth
    },
    interiors
  ]
};

const selectedMenu: SelectedMenu = {
  menuTitle: 'storageone.selectedProductListCustomiseSection',
  behaviors: {
    productDeleted: [deleteSection]
  },
  content: widgets[platform]
};

export default selectedMenu;
